export default "__VITE_ASSET__BezNtJMT__"